'use client';
"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Combobox = Combobox;
const jsx_runtime_1 = require("react/jsx-runtime");
const React = __importStar(require("react"));
const components_1 = require("@aiq/icons/components");
const utils_1 = require("../utils");
const command_1 = require("./command");
const popover_1 = require("./popover");
const forms_1 = require("./forms");
// Searchable picker. Trigger matches the input baseline (38px / 8px radius /
// neutral-100 border). Popover surface uses --aiq-shadow-md.
function Combobox({ value, onChange, items, renderItem, noValueLabel, searchPlaceholder, noResultsLabel, title, className, shouldFilter = true, onChangeValue, triggerRef }) {
    var _a;
    const [open, setOpen] = React.useState(false);
    const selected = items.find(item => item.value === value);
    // `role="combobox"` owes the reader an `aria-controls`; this is the list it opens.
    const listId = `${React.useId()}-list`;
    const handleClear = (e) => {
        e.stopPropagation();
        onChange(undefined);
    };
    // The clear affordance sits inside the trigger button, so it cannot be a button
    // of its own. Giving it the role and a key handler at least makes it reachable.
    const handleClearKeyDown = (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            handleClear(e);
        }
    };
    return ((0, jsx_runtime_1.jsxs)(popover_1.Popover, { modal: false, onOpenChange: setOpen, open: open, children: [(0, jsx_runtime_1.jsxs)("div", { children: [title ? (0, jsx_runtime_1.jsx)(forms_1.FormTitle, { title: title }) : null, (0, jsx_runtime_1.jsx)(popover_1.PopoverTrigger, { asChild: true, children: (0, jsx_runtime_1.jsxs)("button", { "aria-controls": listId, "aria-expanded": open, className: (0, utils_1.cn)('flex h-[38px] w-full min-w-[200px] cursor-pointer items-center rounded-md border border-neutral-100 bg-white px-3 text-left text-[13px]', 'transition-colors hover:border-primary-200 focus:border-primary focus:shadow-[var(--aiq-ring-focus)] focus:outline-none', className), ref: triggerRef, role: 'combobox', type: 'button', children: [(0, jsx_runtime_1.jsx)("span", { className: (0, utils_1.cn)('flex-1 overflow-hidden text-ellipsis whitespace-nowrap', selected ? 'text-neutral-900' : 'text-neutral-400'), children: (_a = selected === null || selected === void 0 ? void 0 : selected.label) !== null && _a !== void 0 ? _a : noValueLabel }), (0, jsx_runtime_1.jsxs)("span", { className: 'ml-auto inline-flex items-center gap-2 pl-2 text-neutral-400', children: [value ? ((0, jsx_runtime_1.jsx)("span", { "aria-label": 'Clear', className: 'cursor-pointer rounded-full p-0.5 hover:bg-neutral-50', onClick: handleClear, onKeyDown: handleClearKeyDown, role: 'button', tabIndex: 0, children: (0, jsx_runtime_1.jsx)(components_1.XFilledIcon, { className: 'h-3 w-3 shrink-0' }) })) : null, (0, jsx_runtime_1.jsx)(components_1.AngleUpDownIcon, { className: 'h-3 w-3 shrink-0' })] })] }) })] }), (0, jsx_runtime_1.jsx)(popover_1.PopoverContent, { className: 'border border-neutral-100 bg-surface p-0 shadow-md', style: { width: 'var(--radix-popover-trigger-width)' }, children: (0, jsx_runtime_1.jsxs)(command_1.Command, { onChange: e => onChangeValue === null || onChangeValue === void 0 ? void 0 : onChangeValue(e.target.value), shouldFilter: shouldFilter, children: [(0, jsx_runtime_1.jsx)(command_1.CommandInput, { className: 'h-10 px-0 text-[13px] focus:outline-none focus:ring-0', placeholder: searchPlaceholder }), (0, jsx_runtime_1.jsx)(command_1.CommandEmpty, { children: noResultsLabel }), (0, jsx_runtime_1.jsx)(command_1.CommandList, { id: listId, children: items.map(item => ((0, jsx_runtime_1.jsx)(command_1.CommandItem, { className: 'py-2', onSelect: () => {
                                    onChange(item);
                                    setOpen(false);
                                }, value: item.value, children: renderItem ? renderItem(item) : item.label }, item.value))) })] }) })] }));
}
